import axios from "axios";
import { useState } from "react";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { notifyUser } from "../utils/notifyUser";

export default function VerifyEmail() {
    const [form, setForm] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });
    const [error, setError] = useState("");
    const [success] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleVerify = async (e) => {
        e.preventDefault();

        if(form.new_password !== form.confirm_password) {
            setError("Passwords do not match");
            return;
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-emailPassword`,
                {
                    token,
                    current_password: form.current_password,
                    new_password: form.new_password,
                    confirm_password: form.confirm_password,
                },
            );
            // setSuccess("Password updated successfully.");
            notifyUser(null, "success", "Password updated succesfully", "toast", null, null, null, null, null, false, false, "top-center");
            setTimeout(() => navigate("/login"), 2000);
        } catch{
            setError("Error updating password. Please try again.");
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white shadow-lg rounded-lg">
                <h2 className="text-2xl font-bold text-center mb-4">
                    Verify Your Email
                </h2>
                {error && (
                    <p className="text-red-500 text-sm text-center">{error}</p>
                )}
                {success && (
                    <p className="text-green-500 text-sm text-center">
                        {success}
                    </p>
                )}

                <form onSubmit={handleVerify} className="space-y-4">
                    <input
                        type="password"
                        name="current_password"
                        placeholder="Current Password"
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <input
                        type="password"
                        name="new_password"
                        placeholder="New Password"
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <input
                        type="password"
                        name="confirm_password"
                        placeholder="Confirm New Password"
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}
